<template>
    <sup v-if="referenceModel">
        <a :id="`p-ref${referenceModel.elements.referenceOrderNumber.value}`" @click="scrollToElement(
        `ref${referenceModel.elements.referenceOrderNumber.value}`)">
            {{ text }}
        </a>
    </sup>
    <sup v-else>{{ text }}</sup>
</template>
<script lang="ts" setup>
import type { ReferenceModel } from '~/models';

const { scrollToElement } = useSmoothScroll()
const props = defineProps<{
    text: string,
}>()

const pageStore = usePageStore()
const referenceModel = ref<ReferenceModel | null>(null)

referenceModel.value = pageStore.getPageReferences()[props.text.trim()] as ReferenceModel

</script>